/**
 * @generated SignedSource<<97feeb5b75bf25e8294b590fec7ff67e>>
 * @relayHash 461d74d5cab5e19d2c36fce8c9a0e073
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b4e266f95fe1b455feb2b6b4d8975fe879ad14d700be73f178eef713064c7707

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useQueriesShareConfigurationQuery$variables = {
  cloudId: string;
};
export type useQueriesShareConfigurationQuery$data = {
  readonly confluence_shareConfiguration: {
    readonly disableSharingToEmails: boolean;
  } | null | undefined;
};
export type useQueriesShareConfigurationQuery = {
  response: useQueriesShareConfigurationQuery$data;
  variables: useQueriesShareConfigurationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "ConfluenceShareConfiguration",
    "kind": "LinkedField",
    "name": "confluence_shareConfiguration",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "disableSharingToEmails"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useQueriesShareConfigurationQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useQueriesShareConfigurationQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "461d74d5cab5e19d2c36fce8c9a0e073",
    "id": "b4e266f95fe1b455feb2b6b4d8975fe879ad14d700be73f178eef713064c7707",
    "metadata": {},
    "name": "useQueriesShareConfigurationQuery",
    "operationKind": "query",
    "text": "query useQueriesShareConfigurationQuery($cloudId:ID!){confluence_shareConfiguration(cloudId:$cloudId){disableSharingToEmails}}"
  }
};
})();

(node as any).hash = "a6d9b1de4c016bbb6b2f6dc8e140b8e8";

export default node;
